(function () {
  var DAY = 24 * 60 * 60 * 1000;

  function startOfDay(d) {
    var n = new Date(d);
    n.setHours(0, 0, 0, 0);
    return n;
  }

  function nextWeekday(from, targetDay) {
    var d = startOfDay(from);
    var diff = (targetDay - d.getDay() + 7) % 7;
    // setDate() instead of adding diff*DAY: a fixed millisecond jump lands an
    // hour short of midnight on any day the span crosses a DST fall-back
    // (clocks gain an hour), which rounds down to the wrong calendar day —
    // confirmed live: the Wednesday button showed "Wednesday" next to the
    // real Tuesday's date right across the Nov 1 2026 DST change. setDate()
    // moves by calendar day regardless of how many real hours that day has.
    d.setDate(d.getDate() + diff);
    return d;
  }

  function formatDate(d) {
    return d.toLocaleDateString('en-CA', { month: 'short', day: 'numeric' });
  }

  function isoDate(d) {
    var mm = String(d.getMonth() + 1);
    if (mm.length < 2) mm = '0' + mm;
    var dd = String(d.getDate());
    if (dd.length < 2) dd = '0' + dd;
    return d.getFullYear() + '-' + mm + '-' + dd;
  }

  // Cutoff is computed relative to the candidate delivery date (the cutoffWeekday
  // immediately before it), not relative to "now" — searching forward from "now"
  // can land on a cutoff *after* the candidate date, wrongly treating an
  // already-missed cutoff as still open.
  function nextDeliveryDate(now, deliveryWeekday, cutoffWeekday, cutoffHour) {
    var candidate = nextWeekday(now, deliveryWeekday);
    var daysBack = (deliveryWeekday - cutoffWeekday + 7) % 7;
    var cutoff = new Date(candidate.getTime());
    cutoff.setDate(cutoff.getDate() - daysBack);
    cutoff.setHours(cutoffHour, 59, 59, 999);
    if (now.getTime() > cutoff.getTime()) {
      candidate = new Date(candidate.getTime());
      candidate.setDate(candidate.getDate() + 7);
    }
    return candidate;
  }

  var now = new Date();
  // Sunday (0) delivery — cutoff Wednesday (3) 11:59pm
  var sunday = nextDeliveryDate(now, 0, 3, 23);
  // Wednesday (3) delivery — cutoff Saturday (6) 11:59pm
  var wednesday = nextDeliveryDate(now, 3, 6, 23);
  // Exposed so reset-menu.js can match the à la carte page's cards against
  // the exact same real calendar dates shown on these buttons, instead of
  // guessing which week is "current" independently — one source of truth
  // for what "Sunday"/"Wednesday" actually means right now.
  window.ResetDeliveryDates = { sun: isoDate(sunday), wed: isoDate(wednesday) };

  // Whichever real date is chronologically nearest goes first/active by
  // default — same behaviour as the Goal Plan page's own start-date picker
  // (reset-goal-plan.js), which this previously didn't match: it always
  // showed Sunday first/active regardless of which was actually sooner.
  var nearestDay = wednesday.getTime() < sunday.getTime() ? 'wed' : 'sun';

  function saveToCart(dateLabel, savedEl) {
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: { 'Delivery Date': dateLabel } })
    })
      .then(function () {
        if (savedEl) savedEl.classList.add('is-visible');
      })
      .catch(function () {
        /* silent — cart may not exist yet on an empty cart page */
      });
  }

  // Confirmed live as the actual cause of a runaway loop flooding /cart.js
  // with dozens of requests a second until Shopify started rate-limiting it
  // (429s) — setting .textContent unconditionally is itself a DOM mutation,
  // which the MutationObserver below (watching the whole page, because
  // Shopify's cart drawer replaces this markup outright on changes) picks
  // up and reacts to by calling this same function again, forever, even
  // when the text was already correct. Only writing when the value has
  // actually changed breaks the loop at its source: once correct, this
  // stops mutating anything, so the observer has nothing left to react to.
  function refreshDates(root) {
    var sunDateEl = root.querySelector('[data-rdel-day-date="sun"]');
    var wedDateEl = root.querySelector('[data-rdel-day-date="wed"]');
    var sunText = formatDate(sunday);
    var wedText = formatDate(wednesday);
    if (sunDateEl && sunDateEl.textContent !== sunText) sunDateEl.textContent = sunText;
    if (wedDateEl && wedDateEl.textContent !== wedText) wedDateEl.textContent = wedText;
  }

  function initRoot(root) {
    // Always refresh the visible date text — cheap, and covers the case where
    // Shopify re-renders this markup fresh (e.g. cart drawer updates) without
    // us knowing, which would otherwise leave the new nodes blank.
    refreshDates(root);

    if (root.dataset.rdelInit === 'true') return;
    root.dataset.rdelInit = 'true';

    // ---- postal code check (optional — only present on the full cart-page section) ----
    var fsas = (root.dataset.fsas || '').split(',').filter(Boolean);
    var postalInput = root.querySelector('[data-rdel-postal-input]');
    var postalBtn = root.querySelector('[data-rdel-postal-check]');
    var postalMsg = root.querySelector('[data-rdel-postal-msg]');

    function checkPostal() {
      if (!postalInput || !postalMsg) return;
      var value = postalInput.value.replace(/\s/g, '').toUpperCase();
      if (value.length < 3) {
        postalMsg.removeAttribute('data-state');
        return;
      }
      var fsa = value.slice(0, 3);
      var inArea = fsas.indexOf(fsa) !== -1;
      postalMsg.textContent = inArea
        ? "We deliver to your area."
        : "We're not delivering there yet — check back soon, or contact us to confirm.";
      postalMsg.setAttribute('data-state', inArea ? 'in' : 'out');
    }

    if (postalBtn) postalBtn.addEventListener('click', checkPostal);
    if (postalInput) {
      postalInput.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') {
          e.preventDefault();
          checkPostal();
        }
      });
    }

    // ---- delivery day toggle (Sunday / Wednesday) ----
    var toggleEl = root.querySelector('[data-rdel-daytoggle]');
    var savedEl = root.querySelector('[data-rdel-saved]');
    var lockMsgEl = root.querySelector('[data-rdel-locked-msg]');
    if (!toggleEl) return;

    var dayButtons = Array.prototype.slice.call(root.querySelectorAll('[data-rdel-day]'));

    // whichever date is chronologically nearest goes first (leftmost) and
    // starts selected — matches reset-goal-plan.js's own start-date picker
    dayButtons.forEach(function (b) { b.classList.toggle('is-active', b.dataset.rdelDay === nearestDay); });
    var nearestBtn = dayButtons.filter(function (b) { return b.dataset.rdelDay === nearestDay; })[0];
    if (nearestBtn && toggleEl.firstElementChild !== nearestBtn) {
      toggleEl.insertBefore(nearestBtn, toggleEl.firstElementChild);
    }

    dayButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        // Locked once the cart has anything in it (see syncLockState below)
        // — switching used to leave an already-added item's own "Delivery
        // Date" line property pointing at the day it was actually added
        // under, even after the toggle (and the cart's own attribute) moved
        // to a different one. Confirmed live: a Wednesday-only item still
        // sitting in the cart with Sunday selected, which isn't a real
        // delivery option. Re-clicking the already-active day is still a
        // no-op either way, locked or not — nothing would actually change.
        if (root.dataset.rdelLocked === 'true' && !btn.classList.contains('is-active')) {
          if (lockMsgEl) lockMsgEl.hidden = false;
          return;
        }
        if (lockMsgEl) lockMsgEl.hidden = true;
        dayButtons.forEach(function (b) { b.classList.toggle('is-active', b === btn); });
        if (savedEl) savedEl.classList.remove('is-visible');
        var day = btn.dataset.rdelDay;
        var d = day === 'sun' ? sunday : wednesday;
        var label = (day === 'sun' ? 'Sunday' : 'Wednesday') + ', ' + formatDate(d);
        saveToCart(label, savedEl);
      });
    });

    // save the default (nearest) selection on first init
    var nearestLabel = (nearestDay === 'sun' ? 'Sunday' : 'Wednesday') + ', ' + formatDate(nearestDay === 'sun' ? sunday : wednesday);
    saveToCart(nearestLabel, savedEl);
  }

  function scanAndInit() {
    Array.prototype.slice.call(document.querySelectorAll('[data-rdel]')).forEach(initRoot);
  }

  // Re-checks the cart on every load/change, independent of initRoot's
  // once-only guard above (that guard only protects the one-time click-
  // listener setup — lock state has to stay live for as long as the page
  // does). Re-queries dayButtons/lockMsgEl fresh each call rather than
  // caching them, same reasoning as the MutationObserver below: Shopify's
  // cart drawer can replace this markup outright on a cart change.
  function syncLockState(root) {
    var dayButtons = Array.prototype.slice.call(root.querySelectorAll('[data-rdel-day]'));
    var lockMsgEl = root.querySelector('[data-rdel-locked-msg]');
    if (!dayButtons.length) return;
    fetch('/cart.js', { cache: 'no-store' })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        // Locked only by à la carte items actually being in the cart — not
        // by cart.item_count overall, which used to also lock this the
        // moment a Goal Plan line was in the cart (e.g. after starting a
        // Goal Plan checkout and coming back without paying). Confirmed
        // live as a real bug: à la carte and Goal Plan are independent
        // delivery streams now (see the minimum-order exemption in
        // reset-cart-minimum.js), so an unrelated Goal Plan line shouldn't
        // freeze this page's own day choice before any à la carte item has
        // actually been added under it. Same backend_plan_id/
        // _backend_plan_id property convention used there to tell a Goal
        // Plan line apart from a real à la carte one.
        var hasAlaCarteItem = (cart.items || []).some(function (item) {
          var props = item.properties || {};
          return !(props.backend_plan_id || props._backend_plan_id);
        });
        var locked = hasAlaCarteItem;
        dayButtons.forEach(function (b) { b.classList.toggle('is-locked', locked); });
        if (lockMsgEl && locked === false) lockMsgEl.hidden = true;
        root.dataset.rdelLocked = locked ? 'true' : 'false';
      })
      .catch(function () {});
  }

  function syncAllLockStates() {
    Array.prototype.slice.call(document.querySelectorAll('[data-rdel]')).forEach(syncLockState);
  }

  scanAndInit();
  syncAllLockStates();
  document.addEventListener('shopify:cart:lines-update', scanAndInit);
  document.addEventListener('shopify:cart:update', scanAndInit);
  document.addEventListener('shopify:cart:lines-update', syncAllLockStates);
  document.addEventListener('shopify:cart:update', syncAllLockStates);

  // Shopify's cart drawer re-renders its own markup from the server on cart
  // changes, which replaces our DOM nodes outright (losing any state/text we'd
  // set). A body-level observer catches that regardless of the exact
  // mechanism/timing Shopify uses internally.
  //
  // The rAF coalescing alone used to be the only guard here, which turned
  // out not to be enough: refreshDates() (now fixed separately) was mutating
  // the DOM on every single call, and that mutation was itself picked up by
  // this same observer, re-triggering it every frame, forever — with
  // syncAllLockStates()'s own fetch('/cart.js') running each time too. That
  // flooded the cart endpoint until Shopify started returning 429s,
  // confirmed live. A minimum real-time gap between actual runs (not just
  // one per animation frame) stays as a second, independent layer against
  // this same class of bug recurring, since a tight mutation loop can still
  // fire many animation frames per second on its own.
  if (window.MutationObserver) {
    var scheduled = false;
    var lastRun = 0;
    var MIN_INTERVAL_MS = 1000;
    var mo = new MutationObserver(function () {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(function () {
        scheduled = false;
        if (Date.now() - lastRun < MIN_INTERVAL_MS) return;
        lastRun = Date.now();
        scanAndInit();
        syncAllLockStates();
      });
    });
    mo.observe(document.body, { childList: true, subtree: true });
  }
})();
